// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2ssV7","topBottomGutter":"Layout_topBottomGutter__2tpDy"};